const palette = {
    primary: '#456AEF',
    success: '#2ECC71',
    warning: '#F1C40F',
    danger: '#E74C3C',
    neutral: ''
};

export default palette;
